export default function shortLinkRewrite(): void {
  // 短链来源配置
  const shortLinkConfig: { [key: string]: string } = {
    aw: '/challenge/8564a2a0deb44d799c7da0fd6c5acdac'
  }
  const hostname: string = location.hostname
  // 判断是否是三级域名
  if (hostname.split('.').length === 3) {
    // 获取三级域名前缀
    const prefix: string = hostname.split('.')[0]
    if (shortLinkConfig[prefix] && !location.href.includes(shortLinkConfig[prefix])) {
      location.href = shortLinkConfig[prefix]
    }
  }
}
